import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposTransferencias } from './tipos_transferencias_service';
import GridBase from '../../../components/grid_base';
export var TiposTransferenciasListar = function () {
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'nome', headerName: 'Nome', width: 500 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(GridBase, { pagina: PAGINAS.TIPOS_TRANSFERENCIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_TRANSFERENCIAS, rota: ROUTES.TIPOS_TRANSFERENCIAS, columns: COLUNAS_FUNCIONALIDADE, fetchData: function (str, _, pag) { return getTiposTransferencias(str, pag); } }));
};
export default TiposTransferenciasListar;
